import { render, staticRenderFns } from "./document.vue?vue&type=template&id=f97b93f4&scoped=true"
import script from "./document.vue?vue&type=script&lang=js"
export * from "./document.vue?vue&type=script&lang=js"
import style0 from "@/utils/style/table.css?vue&type=style&index=0&id=f97b93f4&prod&scoped=true&lang=css&external"
import style1 from "./document.vue?vue&type=style&index=1&id=f97b93f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f97b93f4",
  null
  
)

export default component.exports